import "./gallery.css";
import delegate from "delegate-it";

const FILTER_SELECTOR = "[data-gallery-filter-form]";
const FILTER_SCROLL_SELECTOR = "[data-gallery-filter-scroll]";
const INPUT_SELECTOR = 'input[name="gallery"]';
const ALL_SELECTOR = "[data-gallery-filter-all]";
const GALLERY_SELECTOR = "[data-photo-gallery]";

function getSelectedGallery(form) {
  const selected = form.querySelector(`${INPUT_SELECTOR}:checked`);
  if (!selected || selected.value === "all") return "";
  return selected.value;
}

function applySelectionRules(form, changedInput) {
  const allInput = form.querySelector(ALL_SELECTOR);
  if (!allInput) return;

  if (!changedInput.checked) {
    allInput.checked = true;
  }
}

function buildFilteredPageUrl(selected) {
  const url = new URL(window.location.href);

  if (selected) {
    url.searchParams.set("gallery", selected);
  } else {
    url.searchParams.delete("gallery");
  }

  return url;
}

function buildFilteredStreamUrl(galleryEl, selected) {
  const streamUrl = new URL(galleryEl.dataset.photoGallery, window.location.origin);
  streamUrl.searchParams.delete("offset");
  streamUrl.searchParams.delete("limit");

  if (selected) {
    streamUrl.searchParams.set("gallery", selected);
  } else {
    streamUrl.searchParams.delete("gallery");
  }

  return streamUrl;
}

function reloadGallery(galleryEl, streamUrl) {
  galleryEl.classList.add("is-loading");
  if (!galleryEl.querySelector(".site-loader")) {
    galleryEl.insertAdjacentHTML(
      "afterbegin",
      `<svg class="text-white site-loader" viewBox="0 0 50 50" aria-hidden="true">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>`,
    );
  }

  galleryEl.dispatchEvent(new CustomEvent("photo-gallery:reload", {
    bubbles: true,
    detail: {
      streamUrl: streamUrl.toString(),
    },
  }));
}

function handleFilterChange(e) {
  const input = e.target.closest(INPUT_SELECTOR);
  if (!input) return;

  const form = e.delegateTarget;
  applySelectionRules(form, input);

  const selected = getSelectedGallery(form);
  const pageUrl = buildFilteredPageUrl(selected);
  window.history.replaceState({}, "", pageUrl);

  const galleryEl = document.querySelector(GALLERY_SELECTOR);
  if (!galleryEl) return;

  const streamUrl = buildFilteredStreamUrl(galleryEl, selected);
  reloadGallery(galleryEl, streamUrl);
}

function updateFilterScrollMask(scrollEl, form) {
  const maxScrollLeft = Math.max(0, form.scrollWidth - form.clientWidth);
  const canScroll = maxScrollLeft > 1;
  const isScrolled = form.scrollLeft > 1;
  const isAtEnd = form.scrollLeft >= maxScrollLeft - 1;

  scrollEl.classList.toggle("is-scrollable", canScroll);
  scrollEl.classList.toggle("is-scrolled", canScroll && isScrolled);
  scrollEl.classList.toggle("is-scroll-end", !canScroll || isAtEnd);
}

function bindFilterScrollMask(form) {
  const scrollEl = form.closest(FILTER_SCROLL_SELECTOR);
  if (!scrollEl) return;

  const sync = () => updateFilterScrollMask(scrollEl, form);
  form.addEventListener("scroll", sync, { passive: true });
  window.addEventListener("resize", sync);

  if (typeof ResizeObserver === "function") {
    const observer = new ResizeObserver(sync);
    observer.observe(form);
  }

  requestAnimationFrame(sync);
}

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(FILTER_SELECTOR);
  if (!form) return;

  bindFilterScrollMask(form);
  delegate(FILTER_SELECTOR, "change", handleFilterChange);
});
